"use client"
import styled from "@emotion/styled"
import { sharedTheme } from "./theme/theme"

const StyledContainer = styled.div<{ $withoutPadding?: boolean }>`
  margin: 0 auto;
  max-width: 100%;
  padding-left: ${(p) => (p.$withoutPadding ? "0px" : "10px")};
  padding-right: ${(p) => (p.$withoutPadding ? "0px" : "10px")};
  ${sharedTheme.breakpoints.up("tablet")} {
    max-width: 1600px;
    padding-left: 30px;
    padding-right: 30px;
  }
  ${sharedTheme.breakpoints.up("laptop")} {
  }
  ${sharedTheme.breakpoints.up("lgLaptop")} {
  }

  ${sharedTheme.breakpoints.up("desktop")} {
  }
`
type MainContainerProps = {
  children?: React.ReactNode
  style?: React.CSSProperties
  withoutPadding?: boolean
  containerRef?: React.Ref<HTMLDivElement>
  className?: string
}

export const MainContainer: React.FC<MainContainerProps> = ({
  children,
  style,
  withoutPadding,
  containerRef,
  className,
}: MainContainerProps) => {
  return (
    <StyledContainer
      style={style}
      $withoutPadding={withoutPadding}
      ref={containerRef}
      className={className}
    >
      {children}
    </StyledContainer>
  )
}

export default MainContainer
